import {
  Card,
  Grid,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';
import ExclamationIcon from '../../static/exclamationIcon.svg';
import colors from '../../themes/main-colors';
import { useIsMobile } from '../../util/style-utils';
import React from 'react';

const useStyles = makeStyles(() =>
  createStyles({
    card: {
      padding: '12px',
      background: colors.noirBlur,
      display: 'flex',
    },
    cardMob: {
      padding: '12px',
      background: colors.noirBlur,
      display: 'flex',
      borderLeft: '10px solid #EB7100',
    },
    header: {
      fontSize: '20px',
      fontWeight: 600,
    },
    description: {
      fontSize: '16px',
    },
    contentEndline: {
      fontSize: '18px',
      display: 'inline-block',
      marginLeft: '5px',
    },
    subtext: {
      fontSize: '14px',
    },
    icon: {
      display: 'flex',
      width: '15%',
      justifyContent: 'center',
      alignItems: 'center',
    },
    contentMain: {
      color: 'white',
      marginLeft: '1rem',
    },
    pspsPageLink: {
      display: 'inline-block',
    },
    pspsLinkText: {
      color: 'white',
    },
  }),
);

type PspsWarningCardInfoData = {
  pspsHeader: React.ReactNode;
  isPspsContentEnd?: boolean;
  pspsEndContent?: React.ReactNode;
  description?: React.ReactNode;
};

export function ScheduledOutageCard(props: PspsWarningCardInfoData) {
  const classes = useStyles();
  const isMobile = useIsMobile();
  const { pspsHeader, description } = props;

  return (
    <Grid item>
      <Card className={isMobile ? classes.cardMob : classes.card}>
        {!isMobile && (
          <div className={classes.icon}>
            <ExclamationIcon />
          </div>
        )}
        <div className={isMobile ? classes.pspsLinkText : classes.contentMain}>
          <Typography className={classes.header}>{pspsHeader}</Typography>
          {description && (
            <Typography className={classes.description}>
              {description}
            </Typography>
          )}
        </div>
      </Card>
    </Grid>
  );
}
